<template>
    <div class="algolia-search-banner-wrapper">
        <a
            :href="actionBanner.link"
            :title="actionBanner.title"
            ref="bannerElement"
            @click="onBannerClick()"
        >
            <img
                class="homeslider-img"
                :src="actionBanner.image_mobile"
                :alt="actionBanner.title"
            />
        </a>
    </div>
</template>

<script>
export default {
    name: "ActionBanner",
    props: {
        actionBanner: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            viewPromotionEventTriggered: false,
        };
    },
    methods: {
        onBannerClick() {
            if (typeof window.pushGAEvent === 'function') {
                window.pushGAEvent('select_promotion', {
                    promotion_id: this.actionBanner.id,
                    promotion_name: this.actionBanner.title,
                });
            }
        },
        onScrollEvent() {
            if (this.isInViewport(this.$refs.bannerElement)) {
                if (! this.viewPromotionEventTriggered) {
                    this.viewPromotionEventTriggered = true;

                    if (typeof window.pushGAEvent === 'function') {
                        window.pushGAEvent('view_promotion', {
                            promotion_id: this.actionBanner.id,
                            promotion_name: this.actionBanner.title,
                        });
                    }
                }
            }
        },
        isInViewport(element) {
            if (! element) {
                return false;
            }

            const rect = element.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    },
    mounted() {
        document.addEventListener('scroll', this.onScrollEvent, { passive: true });
    },
    beforeUnmount() {
        document.removeEventListener('scroll', this.onScrollEvent);
    }
};
</script>
